var map = {
	"./arrow-down-blue.svg": 504,
	"./arrow-down-grey.svg": 505,
	"./arrow-right-white.png": 506,
	"./arrow-right.svg": 507,
	"./big_unicorn.png": 259,
	"./blue-loader.svg": 260,
	"./circle-grey.svg": 508,
	"./circle.svg": 509,
	"./coinbaseWalletIcon.svg": 258,
	"./dropdown-blue.svg": 510,
	"./dropdown.svg": 511,
	"./dropup-blue.svg": 512,
	"./empty-token.png": 87,
	"./ethereum-logo.png": 513,
	"./fortmaticIcon.png": 514,
	"./link.svg": 515,
	"./magnifying-glass.svg": 516,
	"./menu.svg": 517,
	"./metamask.png": 168,
	"./noise.png": 261,
	"./plus-blue.svg": 518,
	"./plus-grey.svg": 519,
	"./portisIcon.png": 520,
	"./question-mark.svg": 521,
	"./question.svg": 522,
	"./spinner.svg": 523,
	"./token-list-logo.png": 524,
	"./token-list/lists-dark.png": 525,
	"./token-list/lists-light.png": 526,
	"./token-logo - Copy.png": 527,
	"./token-logo.png": 528,
	"./tokenlistsgrouped.png": 529,
	"./trustWallet.png": 530,
	"./walletConnectIcon.svg": 531,
	"./x.svg": 532,
	"./xl_uni.png": 262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;